export default "__VITE_PUBLIC_ASSET__a8ddb875__"